import {
    SHOW_POPUP,
    HIDE_POPUP,
    SHOW_PROGRESS,
    HIDE_PROGRESS,
    FREIGHT_TYPES_REQUEST,
    FREIGHT_TYPES_SUCCESS,
    FREIGHT_TYPES_FAIL,
    SHOW_FREIGHT_TYPES_POPUP,
    HIDE_FREIGHT_TYPES_POPUP,
    UPDATING_FREIGHT_TYPE,
} from '../constants/action-types';

import {    
    getFreightTypesRequest,
    deleteFreightTypeRequest,
    manageFreightTypeRequest,
} from '../services/api';

import { requestFreights } from './marketsActions';
// TODO
export function getFreightType(id) {
    
}

export function getFreightTypes(cb) {
    return (dispatch) => {
        getFreightTypesRefresh(dispatch, cb)
    }
}

export function createFreightType(cb) {
    return (dispatch) => {
        getFreightTypesRefresh(dispatch, cb)
    }
}

export function deleteFreightType(id, title) {  
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Delete freight type!',
                content: 'You are about to delete '+ title+' - Do you wish to proceed?',
                isConfirm: true,
                buttonAction: () => {
                    dispatch({type: SHOW_PROGRESS});
                    dispatch({type: UPDATING_FREIGHT_TYPE});
                    deleteFreightTypeRequest(id).then( result => {
                        dispatch({type: HIDE_PROGRESS});
                        getFreightTypesRefresh(dispatch);
                    }).catch( error => {
                        dispatch({type: HIDE_PROGRESS});                     
                    });
                }
            }
        });

    }
}

export function showFreightTypePopup(mode, data) {   
    return {
        type: SHOW_FREIGHT_TYPES_POPUP,      
        mode,       
        data: mode == 'update' ? data : {}  
    }
}
export function hideFreightTypePopup() {
    return {
        type: HIDE_FREIGHT_TYPES_POPUP
    }
}

export function manageFreightType(mode, data, clearForm) {   
    return (dispatch) => {
        dispatch({type: SHOW_PROGRESS});
        dispatch({type: UPDATING_FREIGHT_TYPE});
        manageFreightTypeRequest(mode, data).then( result => {         
            dispatch({type: HIDE_PROGRESS});
            getFreightTypesRefresh(dispatch,()=>{
                dispatch({type: HIDE_FREIGHT_TYPES_POPUP});
                clearForm()
            });           
        }).catch( error => {            
            dispatch({type: HIDE_PROGRESS});           
        });
    }
}

 const getFreightTypesRefresh = (dispatch, cb) => {  
    dispatch({ type: FREIGHT_TYPES_REQUEST });
    return getFreightTypesRequest().then( result => {     
        dispatch({
            type: FREIGHT_TYPES_SUCCESS,
            payload: result.data            
        });
        dispatch(requestFreights());
        if (cb && typeof cb == 'function') cb();
    }).catch( error => {
        dispatch({
            type: FREIGHT_TYPES_FAIL,
            error: error
        });
    });
}







// WEBPACK FOOTER //
// ./source/actions/freightTypesActions.js